// extracted by mini-css-extract-plugin
export default {"ligature":"ligature__dd4qW"};